<script>
export default {
    name: "AppointmentsPrint",

    data() {

        return {
            appointments: [],
        };
    },

    mounted() {
      this.$root.loading = true;
      Promise.all([ this.fetchAppointments(), ]).then(() => {
          this.$root.loading = false;
          setTimeout(() => {
            window.print();
          }, 250);
      }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchAppointments() {
             let url = `Appointments/GetPatientVisitReport`;
                 url += `?DoctorId=${this.$route.query.doctor}`;
                 url += `&Datefrom=${this.$route.query.from}`;
                 url += `&Dateto=${this.$route.query.to}`;
                 url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;

             return this.$http.get(url).then(({ data }) => {
               this.appointments = data;
             }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap items-center">
    <tail-address-header></tail-address-header>
    <div class="w-full my-3 p-2 text-center">
      <h5 class="font-medium text-xl">Appointments</h5>
    </div>
    <table class="table text-xs border mt-4">
        <thead>
          <tr>
            <th class="p-tiny">Date</th>
            <th class="p-tiny">Patient</th>
            <th class="p-tiny">Contact</th>
            <th class="p-tiny">Clinic</th>
            <th class="p-tiny">Doctor</th>
            <th class="p-tiny w-1/6">Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="appointment in appointments" :key="appointment.id">
            <td class="p-tiny">{{ appointment.date | dateFormat }}</td>
            <td class="p-tiny">
              <h5 class="text-xs font-bold">{{ appointment.names }}</h5>
              <h5 class="text-xs">MRN: {{ appointment.patientID }}</h5>
              <h5 class="text-xs">
                IP: {{ appointment.ipfileno }} OP: {{ appointment.opfileno }}</h5>
              <h5 class="text-xs">
                ID: {{ appointment.nationalid }}</h5>
            </td>
            <td class="p-tiny">
              <h5 class="text-xs">Residence: {{ appointment.residence }}</h5>
              <h5 class="text-xs font-bold">Cell No: {{ appointment.homE_PHONE }}</h5>
            </td>
            <td class="p-tiny">{{ appointment.clinic }}</td>
            <td class="p-tiny">{{ appointment.doctor }}</td>
            <td class="p-tiny w-1/6 break-words">{{ appointment.comment || `-` }}</td>
          </tr>
        </tbody>
    </table>
</div>
</template>
